import React from 'react'
import { Helmet } from 'react-helmet'
import {IconContext} from "react-icons";
import { FaBootstrap, FaCss3, FaFacebook, FaGit, FaGithub, FaHtml5, FaInstagram, FaJs, FaLinkedin, FaPython, FaReact, FaSass, FaTwitter, FaWordpress } from 'react-icons/fa'
import { SiFirebase } from 'react-icons/si'
import './about.css'

function About({
    ImgSrc,
    headline,
    paragraph,
    FbLink,
    instaLink,
    TwitLink,
    LinkdLink,
    GitHubLink
}) {
    return (
        <>
        <section className='About-Section' id="About">
            <Helmet>
                <title>Haris Khan | About us</title>
            </Helmet>
            <div className='about--grid container'>
                <div className='col'>
                    <img src={ImgSrc} alt='profile pic' />
                    <div className='about--social-media'>
                        <a 
                        href={FbLink}
                        target='_blank'
                        rel="noopener noreferrer"
                        aria-label='Facebook'
                        className='social-icon-link'>
                            <FaFacebook />
                        </a>
                        <a 
                        href={instaLink}
                        target='_blank'
                        rel="noopener noreferrer"
                        aria-label='Instagram'
                        className='social-icon-link'>
                            <FaInstagram />
                        </a>
                        <a 
                        href={TwitLink}
                        target='_blank'
                        rel="noopener noreferrer"
                        aria-label='Twitter'
                        className='social-icon-link'>
                            <FaTwitter />
                        </a>
                        <a 
                        href={LinkdLink}
                        target='_blank'
                        rel="noopener noreferrer"
                        aria-label='LinkedIn'
                        className='social-icon-link'>
                            <FaLinkedin />
                        </a>
                        <a 
                        href={GitHubLink}
                        target='_blank'
                        rel="noopener noreferrer"
                        aria-label='Github'
                        className='social-icon-link'>
                            <FaGithub />
                        </a>
                    </div>
                </div>
                <div className='col--info'>
                    <div className='about--info'>
                    <h1 className='info-headline'>
                            {headline}
                    </h1>
                        <p className='info-para'>
                            {paragraph}
                        </p>
                    </div>
                    <div className='about-progress'>
                        <IconContext.Provider value={{ className: "skill--icons" }}>
                        <FaHtml5 /> <FaCss3 /> <FaJs /> <FaWordpress /> <FaBootstrap /> <FaSass /> <FaGit /> <FaReact /> <SiFirebase /> <FaPython />
                        </IconContext.Provider>
                    </div>
                </div>
            </div>
        </section>  
        </>
    )
}

export default About
